import axios from "axios";

export const updatePassword = async (payload,user) => {
  let usePayload = {
    id:payload.sub,
    obj:{
    ...user
    }
  }
  try {
    let status = await axios.post(
      `${process.env.REACT_APP_EMCONSOLE_API_URL}/v1/user/update_password`,
      usePayload
    );
    return status;
  } catch (err) {
    console.log("error while update user  profile in  keyclock", err.message);
    return {
      message: "Server Not responding! plese try after some time",
      status: 409,
    };
  }
};
